import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { AuthorRuleService } from 'tnx-admin-service/authorization/author-rule/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, ModelSchema } from 'tnx-shared';

@Component({
    selector: 'app-author-rule',
    templateUrl: './author-rule.component.html',
    styleUrls: ['./author-rule.component.scss'],
    providers: [ComponentContextService]
})
export class AuthorRuleComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _authorRuleService: AuthorRuleService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._authorRuleService;
        this.setting.objectName = 'cấu hình';
        this.setting.popupSize.width = 1000;
        this.setting.popupSize.height = 800;


        this.setting.modelSchemas = [
            new ModelSchema({ field: 'name', name: 'Tên', fullName: 'Tên cấu hình', description: 'Tên cấu hình tự động phân vai trò' }),
            new ModelSchema({ field: 'description', name: 'Mô tả', fullName: 'Mô tả cấu hình', description: 'Mô tả cấu hình tự động phân vai trò' }),
            // new ModelSchema({ field: 'moduleCode', name: 'Phân hệ', fullName: 'Phân hệ', description: 'Phân hệ' }),
            // new ModelSchema({ field: 'code', name: 'Mã', fullName: 'Mã vai trò', description: 'Mã vai trò' }),
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'name' }),
            new ColumnSchemaBase({ field: 'description' }),
        ];

        super.ngOnInit();
    }

}
